import type { UserRole } from '../types';

/**
 * Maps console persona (from JWT `accountType`) to the Ask Moo UserRole enum
 * used in the chat stream API.
 */
const PERSONA_TO_ROLE: Record<string, UserRole> = {
  COWBELL: 'SUPER_ADMIN',
  CARRIER: 'UNDERWRITER',
  AGENCY: 'CONCIERGE',
  CUSTOMER: 'CONCIERGE',
  DIGITAL: 'CONCIERGE',
  MSSP: 'RISK_ENGINEERING',
  VENDOR: 'CLAIMS',
  CLUSTER: 'UNDERWRITER',
  POOL: 'UNDERWRITER',
  PREMIUM_PROCESSOR: 'UNDERWRITER',
  RE_INSURER: 'UNDERWRITER',
};

const DEFAULT_ROLE: UserRole = 'UNDERWRITER';

export function mapPersonaToUserRole(
  accountType: string | null | undefined
): UserRole {
  if (!accountType) return DEFAULT_ROLE;
  return PERSONA_TO_ROLE[accountType] || DEFAULT_ROLE;
}
